// To do: Fix responsiveness of table and form
import {
  Heading,
  Container,
  VStack,
  Text,
  Code,
  Button,
  Box,
  FormControl,
  HStack,
  FormLabel,
  Input,
  useToast,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Center,
  SimpleGrid,
  Spacer,
} from "@chakra-ui/react";
import Layout from "../../../layout/Layout";
import { Element } from "react-scroll";
import { useState } from "react";
import { CopyIcon } from "@chakra-ui/icons";
import ContentMenu from "../../../components/content-menu";
import AutocompleteMapComponent from "../../../components/mapcomponent/autocomplete";
import PageComponent from "../../../components/PageComponent";
import {
  convertAutocompleteResultToGeoJSON,
  FeatureCollection,
} from "../../../components/mapcomponent/generic";
import PlacesAutocompleteDocs from "../../../components/api-docs/PlacesAutocompleteDocs";

export default function Autocomplete() {
  const [apiKey, setApiKey] = useState("");
  const [input, setInput] = useState("");
  const [components, setComponents] = useState("");
  const [location, setLocation] = useState("");
  const [locationBias, setLocationBias] = useState("");
  const [locationRestriction, setLocationRestriction] = useState("");
  const [originLat, setOriginLat] = useState("");
  const [originLong, setOriginLong] = useState("");
  const [radius, setRadius] = useState("");
  const [region, setRegion] = useState("");
  const [strictBounds, setStrictBounds] = useState("");
  const [types, setTypes] = useState("");
  const [language, setLanguage] = useState("");
  const [offset, setOffset] = useState("");

  const [results, setResults] = useState<{
    apiResponse: string;
    geoJSON: FeatureCollection;
  } | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const toast = useToast();

  const handleCopy = () => {
    results &&
      results.apiResponse &&
      navigator.clipboard.writeText(results.apiResponse);
    toast({
      title: "Success!",
      description: "API response successfully copied to your clipboard",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };

  async function handleSubmit() {
    try {
      setIsLoading(true);

      const reqBody: { [key: string]: any } = {};

      if (input) {
        reqBody.input = input;
      }
      if (components) {
        reqBody.components = components;
      }
      if (location) {
        reqBody.location = location;
      }
      if (locationBias) {
        reqBody.locationbias = locationBias;
      }
      if (locationRestriction) {
        reqBody.locationrestriction = locationRestriction;
      }
      if (originLat && originLong) {
        reqBody.origin = {
          latitude: parseFloat(originLat), // Ensure these are numbers
          longitude: parseFloat(originLong),
        };
      }
      if (radius) {
        reqBody.radius = radius;
      }
      if (region) {
        reqBody.region = region;
      }
      if (strictBounds) {
        reqBody.strictbounds = strictBounds === "true"; // Convert to boolean
      }
      if (types) {
        reqBody.types = types;
      }
      if (language) {
        reqBody.language = language;
      }
      if (offset) {
        reqBody.offset = parseInt(offset); // Ensure this is a number
      }
      console.log(JSON.stringify(reqBody));

      const response = await fetch(
        `${process.env.REACT_APP_V1_API_SERVER_ENDPOINT}/places/autocomplete`,
        {
          method: "POST",
          headers: {
            "X-Api-Key": apiKey,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(reqBody),
        }
      );
      if (response.status === 401) {
        setIsLoading(false);
        setResults(null);
        toast({
          title: "Error!",
          description: "Please provide a valid API key",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }
      if (response.status !== 200) {
        setIsLoading(false);
        setResults(null);
        toast({
          title: "Error!",
          description: "There was an error fetching data",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      var data = await response.json();

      if (data.suggestions && data.suggestions.length > 0) {
        toast({
          title: "Success!",
          description: "Geocoding successfully completed",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else {
        setIsLoading(false);
        setResults(null);
        toast({
          title: "Error!",
          description: "Please check your input",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      console.log("Data:", data);
      setResults({
        apiResponse: JSON.stringify(data, null, 2),
        geoJSON: convertAutocompleteResultToGeoJSON(data.suggestions),
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setResults(null);
      console.log(error);
      toast({
        title: "Error!",
        description: "There was an error fetching data",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }

  /*
  const documentationMarkdown = [
    "## Autocomplete API",
    "",
    "Returns place and address suggestions based on partial or complete text input.  ",
    "Supports geographic biasing, geographic restriction, and optional distance calculation from an origin point.",
    "",
    "---",
    "",
    "### Base URL",
    "",
    "`https://api.potterstech.com/v1`",
    "",
    "---",
    "",
    "### Endpoint",
    "",
    "`POST /autocomplete`",
    "",
    "**Full URL:**  ",
    "`https://api.potterstech.com/v1/autocomplete`",
    "",
    "---",
    "",
    "### Authentication",
    "",
    "`X-Api-Key: <YOUR_API_KEY>`",
    "",
    "---",
    "",
    "### Headers",
    "",
    "| Header | Required | Description |",
    "| ----- | ----- | ----- |",
    "| Content-Type | yes | application/json |",
    "| X-Api-Key | yes | Your assigned API key |",
    "",
    "---",
    "",
    "### Request Parameters",
    "",
    "#### Required",
    "",
    "| Parameter | Type | Description |",
    "| ----- | ----- | ----- |",
    "| `input` | string | Text input used to generate autocomplete suggestions |",
    "",
    "---",
    "",
    "#### Optional",
    "",
    "| Parameter | Type | Description |",
    "| ----- | ----- | ----- |",
    "| `components` | string | Component filtering, for example `country:in` |",
    "| `language` | string | Response language. Default: `en` |",
    "| `origin` | object | Origin location to calculate distance |",
    "| `locationBias` | object | Bias results toward a geographic area |",
    "| `locationRestriction` | object | Restrict results strictly to a geographic area |",
    "",
    "---",
    "",
    "### Location Bias & Restriction",
    "",
    "You may specify **either** `locationBias` **or** `locationRestriction`.",
    "",
    "#### Circular",
    "",
    "```json",
    "{",
    '  "circle": {',
    '    "center": { "latitude": 17.415680447110905, "longitude": 78.47500453770152 },',
    '    "radius": { "units": "Meters", "value": 5000 }',
    "  }",
    "}",
    "```",
    "",
    "#### Rectangular",
    "",
    "```json",
    "{",
    '  "rectangle": {',
    '    "northeast": { "latitude": 17.43329703236551, "longitude": 78.488302222395 },',
    '    "southwest": { "latitude": 17.390622856047326, "longitude": 78.44499530094147 }',
    "  }",
    "}",
    "```",
    "",
    "---",
    "",
    "### Request Examples",
    "",
    "#### Simple Request",
    "",
    "```json",
    "{",
    '  "input": "NTR Gardens, Khairatabad, Hyderabad, Telangana, India"',
    "}",
    "```",
    "",
    "---",
    "",
    "#### With Circular Location Bias",
    "",
    "```json",
    "{",
    '  "input": "NTR Gardens, Khairatabad, Hyderabad, Telangana, India",',
    '  "locationBias": {',
    '    "circle": {',
    '      "center": { "latitude": 17.415680447110905, "longitude": 78.47500453770152 },',
    '      "radius": { "units": "Meters", "value": 5000 }',
    "    }",
    "  }",
    "}",
    "```",
    "",
    "---",
    "",
    "#### With Rectangular Location Restriction",
    "",
    "```json",
    "{",
    '  "input": "NTR Gardens, Khairatabad, Hyderabad, Telangana, India",',
    '  "locationRestriction": {',
    '    "rectangle": {',
    '      "northeast": { "latitude": 17.43329703236551, "longitude": 78.488302222395 },',
    '      "southwest": { "latitude": 17.390622856047326, "longitude": 78.44499530094147 }',
    "    }",
    "  }",
    "}",
    "```",
    "",
    "---",
    "",
    "#### With Distance From Origin",
    "",
    "```json",
    "{",
    '  "input": "NTR Gardens, Khairatabad, Hyderabad, Telangana, India",',
    '  "origin": { "latitude": 17.406226281946527, "longitude": 78.46905012485428 }',
    "}",
    "```",
    "",
    "---",
    "",
    "### Sample Responses",
    "",
    "#### Simple Response",
    "",
    "```json",
    "{",
    '  "suggestions": [',
    "    {",
    '      "placePrediction": {',
    '        "placeId": "95609768637121397521971935917962",',
    '        "text": {',
    '          "text": "NTR Gardens, Tankbund Road, Tankbund, Hyderabad, Khairatabad, Telangana, India"',
    "        },",
    '        "structuredFormat": {',
    '          "mainText": { "text": "NTR Gardens" },',
    '          "secondaryText": { "text": "Tankbund Road, Tankbund, Hyderabad, Khairatabad, Telangana, India" }',
    "        },",
    '        "types": [],',
    '        "location": "POINT (78.468738 17.412732)"',
    "      }",
    "    }",
    "    // ...",
    "  ]",
    "}",
    "```",
    "",
    "---",
    "",
    "#### With Origin (Distance Included)",
    "",
    "```json",
    "{",
    '  "suggestions": [',
    "    {",
    '      "placePrediction": {',
    '        "placeId": "95609768637121397521971935917962",',
    '        "text": {',
    '          "text": "NTR Gardens, Tankbund Road, Tankbund, Hyderabad, Khairatabad, Telangana, India"',
    "        },",
    '        "structuredFormat": {',
    '          "mainText": { "text": "NTR Gardens" },',
    '          "secondaryText": { "text": "Tankbund Road, Tankbund, Hyderabad, Khairatabad, Telangana, India" }',
    "        },",
    '        "types": [],',
    '        "location": "POINT (78.468738 17.412732)",',
    '        "distanceMeters": 724.1603347930611',
    "      }",
    "    }",
    "    // ...",
    "  ]",
    "}",
    "```",
    "",
    "---",
    "",
    "### Response Field Reference",
    "",
    "#### `suggestions[]`",
    "",
    "| Field | Type | Description |",
    "| ----- | ----- | ----- |",
    "| `placePrediction` | object | A suggested place |",
    "",
    "---",
    "",
    "#### `placePrediction`",
    "",
    "| Field | Type | Description |",
    "| ----- | ----- | ----- |",
    "| `placeId` | string | Unique place identifier |",
    "| `text.text` | string | Full display text |",
    "| `structuredFormat.mainText.text` | string | Primary place name |",
    "| `structuredFormat.secondaryText.text` | string | Address or context |",
    "| `types` | array | Place categories |",
    '| `location` | string | WKT POINT format (`POINT (lon lat)`) |',
    "| `distanceMeters` | number | Distance from origin if provided |",
    "",
    "---",
    "",
    "### Example Requests",
    "",
    "#### cURL",
    "",
    "```bash",
    "curl -X POST \\",
    "  'https://api.potterstech.com/v1/autocomplete' \\",
    "  -H 'Content-Type: application/json' \\",
    "  -H 'X-Api-Key: YOUR_API_KEY' \\",
    '  -d \'{ "input": "NTR Gardens, Khairatabad, Hyderabad, Telangana, India" }\'',
    "```",
    "",
    "---",
    "",
    "#### JavaScript",
    "",
    "```javascript",
    'const res = await fetch("https://api.potterstech.com/v1/autocomplete", {',
    '  method: "POST",',
    "  headers: {",
    '    "Content-Type": "application/json",',
    '    "X-Api-Key": process.env.POTTERS_API_KEY,',
    "  },",
    "  body: JSON.stringify({",
    '    input: "NTR Gardens, Khairatabad, Hyderabad, Telangana, India",',
    "  }),",
    "});",
    "",
    "console.log(await res.json());",
    "```",
    "",
    "---",
    "",
    "#### Python",
    "",
    "```python",
    "import os, requests, json",
    "",
    'url = "https://api.potterstech.com/v1/autocomplete"',
    "headers = {",
    '    "Content-Type": "application/json",',
    '    "X-Api-Key": os.environ["POTTERS_API_KEY"],',
    "}",
    "payload = {",
    '    "input": "NTR Gardens, Khairatabad, Hyderabad, Telangana, India"',
    "}",
    "",
    "resp = requests.post(url, headers=headers, data=json.dumps(payload))",
    "print(resp.json())",
    "```",
    "",
    "---",
    "",
    "### Status Codes",
    "",
    "| Code | Description |",
    "| ----- | ----- |",
    "| 200 | Suggestions returned successfully |",
    "| 400 | Invalid request body |",
    "| 401 | Invalid or missing API key |",
    "| 403 | Access forbidden |",
    "| 429 | Rate limit exceeded |",
    "| 5xx | Server error |",
    "",
    "---",
    "",
    "### Notes",
    "",
    "- Use **locationBias** to influence ranking.",
    "- Use **locationRestriction** to strictly constrain results.",
    "- Providing **origin** enables distance calculation and applies distance-based relevance to the results",
  ].join("\n");
  */

  return (
    <PageComponent
      navItemsV1={[
        { title: "Places Autocomplete API", nav: "api" },
        { title: "Try out the API", nav: "playground" },
        { title: "API Documentation", nav: "documentation" },
        { title: "Base URL", nav: "baseurl" },
        { title: "Endpoint", nav: "endpoint" },
        { title: "Authentication", nav: "authentication" },
        { title: "Headers", nav: "headers" },
        { title: "Request Parameters", nav: "requestparameters" },
        { title: "Location Bias & Restriction", nav: "locationbias" },
        { title: "Request Examples", nav: "requestexamples" },
        { title: "Sample Responses", nav: "sampleresponses" },
        { title: "Response Field Reference", nav: "responsefields" },
        { title: "Example Requests", nav: "examplerequests" },
        { title: "Status Codes", nav: "statuscodes" },
        { title: "Notes", nav: "notes" },
      ]}
      handleCopy={handleCopy}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
      isDisabled={!input || !apiKey}
      result={results}
      documentationComponent={<PlacesAutocompleteDocs />}
      formComponent={
        <>
          <HStack>
            <FormLabel pb={0} mb={0}>
              API Key
            </FormLabel>{" "}
            <Spacer />
            <Input
              isRequired
              type="text"
              w="3fr"
              placeholder="Enter API key"
              borderColor={"#bcbcbc"}
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Input
            </FormLabel>{" "}
            <Spacer />
            <Input
              isRequired
              type="text"
              w="3fr"
              placeholder="Enter location name"
              borderColor={"#bcbcbc"}
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Components
            </FormLabel>{" "}
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="Ex: country:us|country:in"
              borderColor={"#bcbcbc"}
              value={components}
              onChange={(e) => setComponents(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Location
            </FormLabel>{" "}
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="Enter location"
              borderColor={"#bcbcbc"}
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Location Bias
            </FormLabel>{" "}
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="Enter location bias"
              borderColor={"#bcbcbc"}
              value={locationBias}
              onChange={(e) => setLocationBias(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Location Restriction
            </FormLabel>
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="Enter location restriction"
              borderColor={"#bcbcbc"}
              value={locationRestriction}
              onChange={(e) => setLocationRestriction(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Origin Latitude
            </FormLabel>
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="Enter latitude"
              borderColor={"#bcbcbc"}
              value={originLat}
              onChange={(e) => setOriginLat(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Origin Longitude
            </FormLabel>
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="Enter longitude"
              borderColor={"#bcbcbc"}
              value={originLong}
              onChange={(e) => setOriginLong(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Radius (m)
            </FormLabel>{" "}
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="1-1000 (1-50 for sort)"
              borderColor={"#bcbcbc"}
              value={radius}
              onChange={(e) => setRadius(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Region
            </FormLabel>{" "}
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="Ex: us"
              borderColor={"#bcbcbc"}
              value={region}
              onChange={(e) => setRegion(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Strict Bounds
            </FormLabel>{" "}
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="true or false"
              borderColor={"#bcbcbc"}
              value={strictBounds}
              onChange={(e) => setStrictBounds(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Types
            </FormLabel>{" "}
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="Ex: restaurant"
              borderColor={"#bcbcbc"}
              value={types}
              onChange={(e) => setTypes(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Language
            </FormLabel>{" "}
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="Ex: en"
              borderColor={"#bcbcbc"}
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Offset
            </FormLabel>{" "}
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="Enter character offset"
              borderColor={"#bcbcbc"}
              value={offset}
              onChange={(e) => setOffset(e.target.value)}
            />
          </HStack>
        </>
      }
      headerTitle={"Places Autocomplete"}
      headerPath={"v1/places/autocomplete"}
      headerDescription={
        "Returns place and address suggestions based on partial or complete text input. Supports geographic biasing, geographic restriction, and optional distance calculation from an origin point."
      }
    />
  );
}
